import apiClient from 'services/httpClient'
import { API_ENDPOINTS } from 'shared/constants/apiEndpoints'

export async function getConfigs({ excludeTypes, includeTypes, search }) {
    return apiClient.get({
        url: API_ENDPOINTS.configs.list,
        params: { excludeTypes, includeTypes, search },
    })
}

export async function createConfig(data) {
    return apiClient.post({ url: API_ENDPOINTS.admin.configs, data })
}

export async function updateConfig(id, data) {
    return apiClient.put({
        url: `${API_ENDPOINTS.admin.configs}/${id}`,
        data,
    })
}

export async function deleteConfig(id) {
    return apiClient.delete({
        url: `${API_ENDPOINTS.admin.configs}/${id}`,
    })
}

export async function getCurrencies() {
    return apiClient.get({
        url: API_ENDPOINTS.configs.currencies,
    })
}
